import http from "@/utils/request";

const exceptionTaskApi = {
  exceptionTaskList: (data) =>
    http.sendRequest({
      METHOD_NAME: "exceptionTask.list",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  traceDetail: (data) =>
    http.sendRequest({
      METHOD_NAME: "exceptionTask.listTraceLog",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  reException: (data) =>
    http.sendRequest({
      METHOD_NAME: "exceptionTask.reException",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  exportTask: (data) =>
    http.sendRequest({
      METHOD_NAME: "exceptionTask.exportTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default exceptionTaskApi;
